import React from "react";
import Style from "./SubscriptionDate.module.scss";
import { useLocation } from "react-router-dom";

const SubscriptionDate = ({ getTextById, props }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const myClass = currentPath.endsWith("/ar");
  const rtl = myClass ? Style.rtl : "";

  return (
    <div className={`${Style.subdate} ${rtl}`}>
      <div className={Style.box}>
        <h2 className={Style.title}>{getTextById(16)}</h2>
        <p>{props?.data?.start_date}</p>
      </div>
      <div className={Style.separator}></div>
      <div className={Style.box}>
        <h2 className={Style.title}>{getTextById(17)}</h2>
        <p>{props?.data?.end_date || "dd/mm/yyyy"}</p>
      </div>
    </div>
  );
};

export default SubscriptionDate;
